import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useIntercom } from "react-use-intercom";

import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import { CHROME_EXTENSION_URL } from "common/constants";

import useAgencySettings from "../../datahooks/useAgencySettings";
import SettingsItemContainer from "../SettingsItemContainer";

import AimfoxLogoOrange from "assets/aimfoxLogos/aimfox-logo-orange.svg?react";

export default function Extension() {
  const { showNewMessage } = useIntercom();
  const { agencySettings } = useAgencySettings();

  return (
    <SettingsItemContainer className="flex-col">
      <div className="flex items-center gap-x-1.5 mb-1">
        <span className="text-sm-bold">Chrome Extension</span>
        {agencySettings?.use_chrome_extension && (
          <Tag variant="success" size="sm">
            Enabled
          </Tag>
        )}
      </div>
      <p className="text-xs-medium text-black-500 mb-4">
        Let your customers connect LinkedIn accounts via Chrome extension
      </p>
      <div className="p-2 flex items-center gap-x-2 border border-black-100 bg-whiteGray rounded-5xl w-[440px]">
        <div className="flex items-center justify-center size-14 bg-white border-black-200 border rounded-3xl">
          <AimfoxLogoOrange className="size-8" />
        </div>
        <div className="flex-1 flex flex-col gap-y-0.5">
          <span className="text-button-sm">
            Aimfox - Linkedin Session Manager
          </span>
          <span className="text-xs text-black-500">
            You are currently using our brand-neutral Chrome extension
          </span>
        </div>
        <Button
          variant="outline-black"
          size="sm"
          rightIcon={<ArrowUpRight />}
          asChild
        >
          <Link to={CHROME_EXTENSION_URL} target="_blank">
            Web Store
          </Link>
        </Button>
      </div>
      <Alert className="mr-auto w-[440px] mt-3">
        <div className="flex flex-col">
          <div className="gap-x-1.5 flex items-center mb-1 text-xs-bold">
            Branded Chrome Extension
            <Tag variant="primary" size="sm">
              Premium
            </Tag>
          </div>
          Get a custom Chrome extension with your agency's name, logo, and
          branding for a seamless client experience.
          <ul className="list-disc ml-6 mt-2">
            <li>Your agency logo and name</li>
            <li>Custom extension icon</li>
            <li>Published under your developer account</li>
          </ul>
          <Button
            size="sm"
            variant="secondary-purple"
            className="mt-2.5 ml-auto"
            onClick={() => {
              showNewMessage(
                "Hello, i would like to update my agency whitelabel extension",
              );
            }}
          >
            Contact support
          </Button>
        </div>
      </Alert>
    </SettingsItemContainer>
  );
}
